var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useEffect, useState } from 'react';
import Vimeo from '../services/Vimeo';
export var UploadContext = createContext({
    setFileToUpload: function (file) { return null; },
    setName: function (name) { return null; },
    setDescription: function (description) { return null; },
    progress: 0,
    name: '',
    description: '',
    error: '',
    success: false,
    uploadFile: function () { return new Promise(function (resolve) { return resolve(); }); },
    clearState: function () { return null; },
    uploadInProgress: false
});
var UploadProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), fileToUpload = _b[0], setFileToUpload = _b[1];
    var _c = useState(0), progress = _c[0], setProgress = _c[1];
    var _d = useState(''), name = _d[0], setName = _d[1];
    var _e = useState(''), description = _e[0], setDescription = _e[1];
    var _f = useState(''), error = _f[0], setError = _f[1];
    var _g = useState(false), success = _g[0], setSuccess = _g[1];
    var _h = useState(false), uploadInProgress = _h[0], setUploadInProgress = _h[1];
    var uploadFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUploadInProgress(true);
                    if (!fileToUpload) return [3 /*break*/, 2];
                    return [4 /*yield*/, Vimeo.uploader.uploadFile(fileToUpload, name, description)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (progress === 0)
            setUploadInProgress(false);
    }, [progress]);
    var clearState = function () {
        setName('');
        setDescription('');
        setFileToUpload(undefined);
        setUploadInProgress(false);
        Vimeo.uploader.clearState();
    };
    Vimeo.uploader.registerCallbacks(setSuccess, setProgress, setError);
    return (React.createElement(UploadContext.Provider, { value: {
            fileToUpload: fileToUpload,
            setFileToUpload: setFileToUpload,
            progress: progress,
            name: name,
            description: description,
            setName: setName,
            setDescription: setDescription,
            error: error,
            success: success,
            uploadFile: uploadFile,
            clearState: clearState,
            uploadInProgress: uploadInProgress
        } }, children));
};
export default UploadProvider;
